/**
 * How the agent links a planar element in an answer: a markdown link to the
 * fragment `#element:<guid>`, e.g. `[Wand W12](#element:3f2a…)`. A fragment,
 * because the chat's markdown sanitizer drops links with an unknown scheme;
 * the chat renders these as element links (`ChatLink`), not as navigation.
 */
const ELEMENT_LINK_PREFIX = '#element:'

/** The element guid a chat link points at, or null for any other link. */
export const elementGuidOfHref = (href: string | undefined): string | null => {
  if (!href?.startsWith(ELEMENT_LINK_PREFIX)) return null
  const guid = href.slice(ELEMENT_LINK_PREFIX.length).trim()
  return guid === '' ? null : decodeURIComponent(guid)
}
